import { render, staticRenderFns } from "./user_SCI.vue?vue&type=template&id=73a24d2e&"
import script from "./user_SCI.vue?vue&type=script&lang=js&"
export * from "./user_SCI.vue?vue&type=script&lang=js&"
import style0 from "./user_SCI.vue?vue&type=style&index=0&id=73a24d2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports